class DeleteEntry
    constructor: (el) ->
        @.$el = el
        @.$cancelButton = @.$el.querySelector '.delete-entry__cancel'
        @.$confirmButton = @.$el.querySelector '.delete-entry__confirm'
        @.$errorEl = @.$el.querySelector '.delete-entry__error'
        @.$parentOverlay = @.$el.closest '.overlay'
        @.$previewTextEl = @.$el.querySelector '.delete-entry__content__preview-text'
        @.$successEl = @.$el.querySelector '.delete-entry__success'

        @.api = @.$el.dataset?.api ? false
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.errorActive = @.$el.classList.contains 'delete-entry--error'
        @.postId = false
        @.previewActive = @.$el.classList.contains 'delete-entry--preview'
        @.successActive = @.$el.classList.contains 'delete-entry--success'
        @.successRedirect = @.$el.dataset?.successRedirect ? false

        @.$el.classList.add 'delete-entry--bound'
        @.InitEvents()
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'delete-entry-preview', (e) ->
            preview = e.detail?.preview ? false
            postId = e.detail?.postId ? false
            if preview && postId
                self.$previewTextEl.innerHTML = preview
                self.$el.classList.add 'delete-entry--preview'
                self.previewActive = true
                self.postId = postId
            else
                self.$el.classList.remove 'delete-entry--preview'
                self.previewActive = false
                self.postId = undefined
            return
        if @.$cancelButton
            @.$cancelButton.addEventListener 'click', (e) ->
                if self.$parentOverlay
                    self.$parentOverlay.dispatchEvent new CustomEvent 'overlay-close', {bubbles: false}
                return
        if @.$confirmButton
            @.$confirmButton.addEventListener 'click', (e) ->
                self.SendData()
                return
        return

    RedirectAction: ->
        if @.successRedirect
            if @.$parentOverlay
                if @.$parentOverlay.dataset?.id
                    overlayEl = document.getElementById @.$parentOverlay.dataset.id
                    if overlayEl
                        redirectOnClose = "#{@.successRedirect}"
                        overlayEl.dispatchEvent new CustomEvent 'overlay-set-redirect-on-close', {
                            bubbles: false,
                            detail: {
                                redirectOnClose: redirectOnClose
                            }
                        }
            else
                if @.successRedirect == "reload"
                    window.location.reload()
                else
                    window.location @.successRedirect
        return
    
    SendData: ->
        if (@.apiMethod == 'GET' || @.apiMethod == 'POST') && @.api && @.postId
            self = @
            try
                if @.apiMethod == 'POST'
                        body = {
                            post: @.postId
                        }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                response = JSON.parse request.responseText
                                if response.success
                                    self.SetSuccessMessage response.message
                                    self.RedirectAction()
                                if response.error
                                    self.SetErrorMessage response.message
                            catch error
                                console.log "Beim Versuch Daten zu senden trat ein Fehler auf", error
                                return
                        else
                            console.log "Die Antwort der Schnittstelle auf die gesendeten Daten war leer oder blieb aus."
                    , ->
                        console.log "Bei der Anfrage an die Schnittstelle ist leider ein Fehler aufgetreten"
                        return
                    , if self.apiMethod == 'POST' then JSON.stringify(body) else {}
            catch error
                console.log "Beim Versuch Daten zu senden trat ein Fehler auf", error
        return
    
    SetErrorMessage: (errorMessage) ->
        if errorMessage && errorMessage != ""
            @.successActive = false
            @.$el.classList.remove 'delete-entry--success'
            @.$errorEl.innerHTML = errorMessage
            @.errorActive = true
            @.$el.classList.add 'delete-entry--error'
        else
            @.errorActive = false
            @.$el.classList.remove 'delete-entry--error'
            @.$errorEl.innerHTML = ""
        return
    
    SetSuccessMessage: (successMessage) ->
        if successMessage
            @.errorActive = false
            @.$el.classList.remove 'delete-entry--error'
            @.$successEl.innerHTML = successMessage
            @.successActive = true
            @.$el.classList.add 'delete-entry--success'
        else
            @.successActive = false
            @.$el.classList.remove 'delete-entry--success'
            @.$successEl.innerHTML = ""
        return

BindDeleteEntries = ->
    document.querySelectorAll '.delete-entry:not(.delete-entry--bound)'
        .forEach (el) ->
            new DeleteEntry el
            return
    return

window.addEventListener 'bind-components', BindDeleteEntries